import { InjectionToken } from "@angular/core";

export abstract class IUserPasswordSetDialogService
{

  abstract passwordSetDialogShow(
    modalTitle: string,
    callbackSubmit: () => void,
    callbackCancel: () => void,
    submitButtonLabel?: string,
    cancelButtonLabel?: string,
  ): unknown;

}

/** Injection token which makes it possible to provide and inject the interface. */
// eslint-disable-next-line @typescript-eslint/naming-convention
export const IUserPasswordSetDialogServiceToken = new InjectionToken<IUserPasswordSetDialogService>('IUserPasswordSetDialogServiceToken');

